/* global Modalytics */
import { getFormsServiceApiDomain } from '../../helpers';
export function trackEcommerceWidgetEvents(hashedDCK, vendorKey, payload = {}, onComplete) {
	if (!hashedDCK || !vendorKey || !payload) {
		return false;
	}

	const isCompletedEvent = typeof payload.name === 'string' && payload.name.includes('Completed');
	const URL = `${getFormsServiceApiDomain()}/leads/${hashedDCK}/widgets/${vendorKey}/events`;
	const request = new XMLHttpRequest();
	let callBackCompleted = false;
	let timeout;

	request.open('POST', URL);
	request.setRequestHeader('Content-Type', 'application/json');

	if (isCompletedEvent && typeof onComplete === 'function') {
		request.addEventListener('load', function() {
			if (!callBackCompleted) {
				callBackCompleted = true;
				clearTimeout(timeout);
				onComplete('success');
			}
		});

		request.addEventListener('error', function() {
			if (!callBackCompleted) {
				callBackCompleted = true;
				clearTimeout(timeout);
				onComplete('error');
				console.error('Something went wrong');
				Modalytics.heap('track', [payload.name + ' | API Error']);
			}
		});
	} else {
		request.addEventListener('error', function() {
			console.error('Something went wrong');
			Modalytics.heap('track', [payload.name + ' | API Error']);
		});
	}

	request.send(JSON.stringify(payload));

	// Giving the API .5 seconds to respond (we will continue regardless & log that the request took too long)
	if (isCompletedEvent && typeof onComplete === 'function') {
		Modalytics.heap('track', [payload.name + ' | API Called']);

		timeout = setTimeout(() => {
			if (!callBackCompleted) {
				callBackCompleted = true;
				Modalytics.heap('track', [payload.name + ' | Timeout Reached']);
				onComplete('timeout');
			}
		}, 500);
	}
}
